<template>
  <div>
    <NavigationBar
      titel="Zielvorgaben"
      :tabs="tabs"
      :activeTab="activeTab"
    ></NavigationBar>
    <router-view />
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import {
  MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_ANALYSIS_read,
  MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_ALL_read,
} from "@/data/permission-types.js";

export default {
  name: "member-management-performance-targets",
  components: {
    NavigationBar,
  },
  data() {
    return {
      activeTab: `overview`,
      tabs: [
        {
          id: 1,
          name: "Übersicht",
          route: `overview`,
          permission: `${MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_ALL_read}`,
        },
        {
          id: 2,
          name: "Analyse",
          route: `analysis`,
          // disabled: true,
          permission: `${MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_ANALYSIS_read}`,
        },
        { id: 3, name: "Definitionen", route: `definitions` },
        {
          id: 4,
          name: "Ausnahmen",
          route: `exceptions`,
          permission: `${MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_ANALYSIS_read}`,
        },
      ],
    };
  },
  computed: {},
};
</script>
